
import Barcode from 'react-barcode';
import { datinNumber, templateMock } from './constant';
import { getDay } from 'tools/functions/Methods';
const PdfTemplate4 = ({ data, userInfo }: any) => {
  const renderData = data || templateMock;
  return (
    <>
      {renderData &&
        renderData.map((item: any) => (
          <div
            key={item.id}
            className=" templates [&>div]:text-[10px] flex items-center gap-x-1 justify-center  w-[18cm] h-[6cm] font-arial text-[12px] mb-[10px]"
          >
            <div className="w-[9cm] h-[4cm] ">
              <div className=" flex flex-row">
                <div className="temp-row w-1/6 flex-none">گیرنده</div>
                <div className="temp-row w-2/3 flex-none">{item.receiverProspectName}</div>
                <div className="temp-row w-1/5 flex-1 text-center">{item?.printIndex}</div>
              </div>
              <div className=" flex flex-row">
                <div className="temp-row w-1/6  flex-none">آدرس</div>
                <div className="temp-row w-2/3 flex-1">
                  {' '}
                  {item.receiverState?.text
                    ? `${item.receiverState.text}-${item.receiverCityName || ''}`
                    : item.receiverCityName || ''}
                </div>
              </div>
              <div className=" flex flex-row  h-[2.4rem]">
                <div className="temp-row  flex-1"> {item.receiverAddress}</div>
              </div>

              <div className=" flex flex-row">
                <div className="temp-row w-1/2 flex-none">
                  پس کرایه :
                  {item.paymentBy?.id === 0 ? ' ___ ' : `دارد `}
                  <br />
                  {item.paymentBy?.id === 0 ? '' : `مبلغ :  ${item.grossPrice?.toLocaleString()}`}
                </div>
                <div className="temp-row flex-1">
                  پرداخت در محل:
                  <br />
                  {`مبلغ : ${item.costOfGoods?.toLocaleString() || ''}`}
                </div>
              </div>

              <div className=" flex flex-row">
                <div className="temp-row w-1/3">کد پستی:</div>
                <div className="temp-row w-1/2">تلفن: {item.receiverProspectMobile}</div>
                <div className="temp-row w-1/5">{getDay(item.createdDate)}</div>
              </div>
            </div>
            <div className="   w-[5cm] h-[4cm]  ">
              <div className=" flex flex-row">
                <div className="p-1  w-1/4  border border-black -m-[.5px] flex-none">فرستنده</div>
                <div className="temp-row flex-1">{item.senderName}</div>
              </div>
              <div className=" flex flex-row">
                <div className="temp-row w-1/4 flex-none">آدرس</div>
                <div className="temp-row flex-1">{item.senderCityName}</div>
              </div>
              <div className=" flex flex-row  h-[3.3rem]">
                <div className="temp-row  flex-1">{item.senderAddress}</div>
              </div>
              <div className=" flex flex-row  ">
                <div className="temp-row flex-1"> کد پستی: </div>
              </div>
              <div className=" flex flex-row  ">
                <div className="temp-row flex-1">
                  {`پشتیبانی: ${
                    userInfo?.text === 'datin' || userInfo?.text === datinNumber ? '02124597775' : '90007030'
                  }`}
                </div>
              </div>
            </div>

            <div className=" barcode relative" style={{ width: '2cm' }}>
              <div className="!rotate-90 scale-[.65]  barcode-container  relative top-14" style={{ width: '2.5cm' }}>
                <div className="barcodeWrapper">
                  <Barcode value={item.cprNumber} displayValue={item.senderMobile !== datinNumber} />
                </div>
              </div>
            </div>
          </div>
        ))}

      <style>{`
            @media print {
              @page {
                size: 18cm 6cm;
                margin: 0;
              }   
            }
            `}</style>
    </>
  );
};

export default PdfTemplate4;
